import React, { ReactNode, createContext, useContext } from 'react'

import { SUPPORTED_CLASSIFICATION_TYPES } from '@documents/constants'
import { ClassificationResult, FileUploadState } from '@documents/types'
import { SelectedFileToRemove } from '@documents/v2/screens/upload-documents'

type ContextValue = {
  hideClassification: boolean
  fileUploadState: FileUploadState
  setSelectedFileToRemove: (selected: SelectedFileToRemove) => void
  classificationResults?: ClassificationResult[]
  hasSupportedClassification: boolean
}

const DocumentCardContext = createContext<ContextValue | null>(null)

type Props = {
  children: ReactNode
  hideClassification: boolean
  fileUploadState: FileUploadState
  setSelectedFileToRemove: (selected: SelectedFileToRemove) => void
  classificationResults?: ClassificationResult[]
}

export function DocumentCardContextProvider({
  children,
  hideClassification,
  fileUploadState,
  setSelectedFileToRemove,
  classificationResults,
}: Props) {
  const hasSupportedClassification = !!classificationResults?.some((cr) => SUPPORTED_CLASSIFICATION_TYPES.includes(cr))

  return (
    <DocumentCardContext.Provider
      value={{
        hideClassification,
        fileUploadState,
        setSelectedFileToRemove,
        classificationResults,
        hasSupportedClassification,
      }}
    >
      {children}
    </DocumentCardContext.Provider>
  )
}

export function useDocumentCardContext() {
  const context = useContext(DocumentCardContext)

  if (!context) {
    throw new Error('useDocumentCardContext must be used within a DocumentCardContextProvider')
  }

  return context
}
